import { Box } from "@mui/system";
import PlainEnglishCardData from "./PlainEnglishCardData";

interface Props {
  /** API key of the column the user clicked, e.g. "total_income_usd" */
  columnKey?: string;
}

const PlainEnglish = ({ columnKey }: Props) => {
  return (
    <>
      <Box px={2} py={1}>
        <PlainEnglishCardData columnKey={columnKey} />
      </Box>
    </>
  );
};

export default PlainEnglish;
